import { css } from 'styled-components';

// TODO: создать систему теней
export const boxShadow =
  '0 10px 15px 0 rgba(216, 214, 204, 0.9), 0 1px 2px 0 rgba(210, 208, 197, 0.9)';

export default {
  elements: {
    tooltip: {
      primary: '#ffffff',
      warning: '#f8e71c',
      error: '#f9eaec',
    },
    button: {
      primary: css<{ disabled: boolean }>`
        background-image: linear-gradient(to bottom, #ffe700, #ffd000);
        border-width: 0;
        border-bottom: 2px solid #b27e01;
        border-radius: 2px;
        color: #000;

        ${({ disabled }) =>
          !disabled &&
          `
          :hover {
            background-image: linear-gradient(to bottom, #ffe700, #ffea00);
          }

          :active {
            background-image: linear-gradient(to top, #ffe700, #ffd000);
            border: 0;
            box-shadow: 0 -1px 0 0 #b27e01;
          }
        `}

        ${({ disabled }) =>
          disabled &&
          `
          opacity: 0.2;
        `}
      `,
    },
  },
  colors: {
    black: '#000000',
    blackBase: '#17181a',
    purpleBrown: '#160c0d',
    blackLight: '#4d4d4d',
    lightGrey: '#d6d5c9',
    paleGrey: '#ece8f1',
    butteryWhite: '#fffbe8',
    concrete: '#f2f2f2',
    greyLight: '#919499',
    frenchGray: '#c2c5cc',
    whiteLight: '#e6e9ee',
    brightBlue: '#005eff',
    blue: '#007aff',
    brightBlueAlpha: 'rgba(0, 94, 255, 0.6)',
    laPalma: '#15b323',
    lightGreen: '#6ab517',
    brightTeal: '#00ffc1',
    pinkBase: '#f9eaec',
    yellowBase: '#f8e71c',
    gold: '#ffd600',
    beige: '#f3f2e8',
    white: '#ffffff',
    greyishBrown: '#574337',
    veryLightPink: '#f5f3f2',
    nomad: '#b8b6a6',
    monza: '#d0021b',
    solitude: '#e6f2ff',
    moonMist: '#d6d5c3',
    snowFlurry: '#e5ffcb',
    greenApple: '#3cbf1f',
    veryLightGreen: '#e4ffc9',
    darkishPurple: '#4b137b',
    coolGrey: '#919499',
    cloudyBlue: '#c2c5cc',
    topey: '#f1f7d2',
    yellowLight: '#fffbe5',
    greySoft: '#565a5f',
  },
  typography: {
    headline1: css`
      font-size: 28px;
      font-weight: bold;
    `,
    headline2: css`
      font-size: 22px;
      font-weight: bold;
    `,
    headline3: css`
      font-size: 18px;
      font-weight: bold;
    `,
    headline4: css`
      font-size: 14px;
      font-weight: bold;
    `,
    headline5: css`
      font-size: 14px;
      font-weight: bold;
    `,
    headline6: css`
      font-size: 12px;
      font-weight: bold;
    `,
    headline7: css`
      font-size: 12px;
    `,
    text1: css`
      font-size: 14px;
    `,
    text2: css`
      font-size: 12px;
      letter-spacing: 0.9px;
    `,
    text3: css`
      font-size: 12px;
    `,
    mobileHeadline1: css`
      font-size: 15px;
      font-weight: bold;
    `,
    mobileHeadline2: css`
      font-size: 13px;
      font-weight: bold;
    `,
    mobileHeadline3: css`
      font-size: 11px;
      font-weight: bold;
    `,
    mobileHeadline4: css`
      font-size: 11px;
      font-weight: bold;
    `,
    t1s: css`
      font-size: 13px;
    `,
    t2s: css`
      font-size: 11px;
    `,
  },
  shape: {
    borderRadius: '4px',
    borderRadiusBig: '6px',
  },
  gradient: {
    darkBlueToLight: (angle = 0) => css`
      background-image: linear-gradient(${angle}deg, #5ac9f5, #1f80f1);
    `,
  },
};
